import { Avatar, makeStyles } from '@fluentui/react-components';
import { AuthenticatedUser } from '../types';

interface Props { user: AuthenticatedUser | null; }

const SYMBOL_LOGO_URL =
  'https://hcpspubliccdn.blob.core.windows.net/publiccdn/Take5/Harleys_Logo_Symbol.png';

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '10px',
    paddingTop: '12px',
    paddingBottom: '10px',
    paddingLeft: '18px',
    paddingRight: '18px',
    backgroundColor: 'transparent',
    borderBottomWidth: 0,
    flexShrink: 0,
  },
  logo: {
    height: '42px',
    width: '42px',
    flexShrink: 0,
    objectFit: 'contain',
    backgroundColor: 'transparent',
    borderRadius: 0,
    boxShadow: 'none',
    filter: 'drop-shadow(0 8px 14px rgba(0,0,0,0.18))',
  },
  textWrap: {
    fontSize: '15px',
    fontWeight: 650,
    color: '#FFFFFF',
    lineHeight: 1.15,
    flex: 1,
    minWidth: 0,
  },
  sub: {
    fontWeight: 600,
    color: '#FFB7BA',
    fontSize: '9.5px',
    letterSpacing: '0.8px',
    marginTop: '2px',
  },
  userChip: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    columnGap: '8px',
    flexShrink: 0,
    maxWidth: '40%',
  },
  userName: {
    fontSize: '11.5px',
    fontWeight: 500,
    color: 'rgba(255,255,255,0.78)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '@media screen and (max-width: 420px)': {
      display: 'none',
    },
  },
});

export function HcpsHeader({ user }: Props) {
  const styles = useStyles();
  return (
    <div className={styles.header}>
      <img className={styles.logo} src={SYMBOL_LOGO_URL} alt="Harley's Plumbing" />
      <div className={styles.textWrap}>
        Harley's Complete Plumbing Services
        <div className={styles.sub}>HOME SAFE. EVERY DAY.</div>
      </div>
      {user && (
        <div className={styles.userChip}>
          <Avatar name={user.name} size={28} color="brand" />
          <span className={styles.userName}>{user.name}</span>
        </div>
      )}
    </div>
  );
}
